module.exports = __webpack_public_path__ + "img/pic_banner_education.1d738967.png";